<div
  title="Selecione uma Imagem"
  (click)="typeCes !== typeCesEnum.SHOW ? selectImage() : ''"
  matRipple
  [matRippleDisabled]="this.typeCes === typeCesEnum.SHOW"
  [ngClass]="
    this.typeCes === typeCesEnum.SHOW
      ? 'image-field'
      : 'image-field image-cursor'
  "
  [formGroup]="group"
>
  <div class="image-title" *ngIf="this.config.label">{{ this.config.label }}</div>
  <input
    accept="image/*"
    #uploadFile
    (change)="upload($event)"
    type="file"
    style="display: none"
  />
  <input
    type="hidden"
    [formControlName]="config.name"
  />
  <!-- [ngModel]="group.get(this.config.name)?.getRawValue()" -->
  <div class="image-content">
    <img
      class="image-display"
      *ngIf="image || group.get(this.config.name)?.getRawValue()"
      [src]="image ? image : getImgUri()"
    />
    <!-- <mat-icon *ngIf="!image" class="icon-display"
      >photo_size_select_actual</mat-icon
    > -->
  </div>
  <div *ngIf="typeCes !== typeCesEnum.SHOW" class="image-text" [ngClass]="this.config.label ? 'image-text-top10px' : 'image-text-top20px'">
    <p *ngIf="!image">SELECIONAR IMAGEM</p>
    <p *ngIf="image">TROCAR IMAGEM</p>
  </div>
</div>
